import { render, staticRenderFns } from "./CardAgendamento.vue?vue&type=template&id=29d5c5f7&scoped=true"
import script from "./CardAgendamento.vue?vue&type=script&lang=ts"
export * from "./CardAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./CardAgendamento.vue?vue&type=style&index=0&id=29d5c5f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d5c5f7",
  null
  
)

export default component.exports